import logo from './logo.svg';
import './App.css';
import React from 'react';
import PieChart3D from './PieChart3D'; // Import the 3D Pie Chart component

function App() {
  return (
    <div className="App">
      <h1>Stack'd</h1>
      <PieChart3D />
    </div>
  );
}

export default App;
